import styled from 'styled-components'

export const PoolFilterSelect = styled.select`
  appearance: none;
  background-color: ${({ theme }) => theme.bg3};
  border: none;
  border-radius: 1rem;
  color: ${({ theme }) => theme.text3};
  display: flex;
  outline: none;
  padding: 0.5rem 1rem;
  transition: ${({ theme }) => theme.TRANSITION.fast};

  &:hover {
    background-color: ${({ theme }) => theme.bg4};
  }
`

export const PoolFilterOption = styled.option`
  border: none;
  display: inline-block;
  outline: none;
  padding: 0.5rem;
`
